import { Component, OnInit } from '@angular/core';
import { GeneralWPService } from 'src/app/core/http/web/generalWp.service';

@Component({
  selector: 'app-web',
  templateUrl: './web.component.html',
  styleUrls: ['./web.component.css']
})
export class WebComponent implements OnInit {
  public data: any;
  public loarChild: any;
  public loadPage: boolean;
  constructor(private wpServ: GeneralWPService) {
    sessionStorage.clear();
    this.getGeneralOptions();
  }
  getGeneralOptions() {
    this.wpServ.getGeneralOptions().subscribe(data => {
      // console.log('Data general web:', data.data);
      this.data = data.data;
      this.loadPage = true;
      this.loarChild = false;
    }, err => {
      console.error('Error en serv getGeneralOptions', err);
      this.loadPage = true;
      this.loarChild = true;
    });
  }

  ngOnInit() {}


  showMoreInfo(){
    // console.log("MoreInfoShow");
  }
}
